import React from 'react'
import About from '../components/About'
import page from '~utils/page'
import { RESOURCES } from '~shared/Nav'
import Head from '~shared/Head'

// eslint-disable-next-line import/no-unused-modules
export default page(About, {
    highlight: RESOURCES,
    headComponent: (
        <Head
            mediaDescription="Team members and office locations"
            description="Meet the Streamr team and get more details about the Streamr project."
        />
    ),
})
